import IFooterContent from '../../models/footer-content.model';

export const footerContent: IFooterContent = {
  copyright: 'studyprime.de'
};
